// sourced from:
// https://github.homeawaycorp.com/traveler/node-traveler-search-ui/blob/15b86558733189f50df68e47913ff183a360ab23/src/universal/utils/scrollToAnimated.js

// easing equations from https://github.com/danro/easing-js/blob/master/easing.js
const easingEquationFunctions = {
    easeOutSine(pos) {
        return Math.sin(pos * (Math.PI / 2));
    },
    easeInOutSine(pos) {
        return -0.5 * (Math.cos(Math.PI * pos) - 1);
    },
    easeInOutQuint(pos) {
        let halfPos = pos / 0.5;
        if (halfPos < 1) {
            return 0.5 * Math.pow(halfPos, 5);
        }
        return 0.5 * (Math.pow(halfPos - 2, 5) + 2);
    },
};

function scrollToAnimated(
    scrollTargetY = 0,
    speed = 2000,
    easing = 'easeOutSine',
    callback
) {
    let scrollY =
        window.scrollY ||
        (document &&
            document.documentElement &&
            document.documentElement.scrollTop) ||
        0;
    let currentTime = 0;

    // min time .1, max time .8 seconds
    let time = Math.max(
        0.1,
        Math.min(Math.abs(scrollY - scrollTargetY) / speed, 0.8)
    );

    // add animation loop
    const tick = () => {
        currentTime += 1 / 60;

        let p = currentTime / time;
        let t = easingEquationFunctions[easing](p);

        if (p < 1) {
            requestAnimationFrame(tick);

            window.scrollTo(0, scrollY + (scrollTargetY - scrollY) * t);
        } else {
            window.scrollTo(0, scrollTargetY);
            if (callback) {
                callback();
            }
        }
    };

    // call it once to get started
    tick();
}

export default scrollToAnimated;
